import { render, staticRenderFns } from "./ReportPromotionSummaries.vue?vue&type=template&id=7528f532&"
import script from "./ReportPromotionSummaries.vue?vue&type=script&lang=js&"
export * from "./ReportPromotionSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports